// extracted by mini-css-extract-plugin
export default {"meinian-inspiration-dynamic":"index_meinian-inspiration-dynamic__RrSWO"};